<template>
    <div v-if="image" class="rounded-md relative w-full h-1/2 items-center">
        <img v-if="!image[1]" :src="'/storage/' + image.filename" alt="ProductImage"
            class="h-auto w-full self-center mb-2 rounded-lg shadow-xl shadow-black"
        />
        <img v-if="image[1]" :src="image[1]" alt="ImagePreview"
            class="h-auto w-full self-center mb-2" :width="width" :height="height"
        />
        <div v-show="showRemoveImage" class="absolute z-50 top-8 bg-white text-center rounded-lg border border-gray shadow-lg">
            <h2 class="bg-red-400 text-white px-4 py-2 rounded-t-lg">Delete Current Image</h2>
            <div class="my-6">Are you sure?</div>

            <div class="mt-4 mb-2 w-full">
                <jet-button @click.prevent="reset" class="mr-3">
                    Yes
                </jet-button>

                <jet-tertiary-button @click.prevent="showRemoveImage = false;" class="ml-3">
                    No
                </jet-tertiary-button>
            </div>
        </div>

        <div v-if="!showRemoveImage" class="bg-white rounded-md border border-gray p-2 absolute bottom-2 right-2 z-10">
            <img src="/images/icons/trash.svg" width="20" height="20" alt="DeleteImage"
                class="cursor-pointer" @click="showRemoveImage = true"
            />
        </div>
    </div>
</template>

<script>
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';

export default {
    components: {
        JetButton,
        JetTertiaryButton,

    },

    props: ['image', 'index', 'width', 'height'],

    data () {
        return {
            showRemoveImage: false
        }
    },

    methods: {
        reset () {
            this.showRemoveImage = false;
            this.$emit('reset', this.index);
        },
    },
}
</script>
